import Lenis from "lenis";

let lenisInstance: Lenis | null = null;

export const setLenis = (l: Lenis | null) => {
  lenisInstance = l;
};

export const getLenis = () => lenisInstance;

/** Rola suavemente até uma âncora (#id), usando Lenis quando disponível. */
export const scrollToAnchor = (hash: string) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (lenisInstance) {
    lenisInstance.scrollTo(el as HTMLElement, { offset: -72, duration: 1.4 });
  } else {
    (el as HTMLElement).scrollIntoView({ behavior: "smooth", block: "start" });
  }
};
